import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Icon,
  Text,
  Box,
  IconButton,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Stack,
  CheckboxGroup,
  Select,
  Divider,
  Flex,
  useDisclosure,
} from "@chakra-ui/react";
import { format } from "date-fns";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./s.css";
import { EditIcon } from "@chakra-ui/icons";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Calendar = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [teachers, setTeachers] = useState([]); // Store fetched teachers

  const [loading, setLoading] = useState(true);
  const [eventColor, setEventColor] = useState("");
  const [error, setError] = useState(null);

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const schoolId = sessionStorage.getItem("school_id");

  const {
    isOpen: isDetailModalOpen,
    onOpen: onOpenDetailModal,
    onClose: onCloseDetailModal,
  } = useDisclosure();

  const [formData, setFormData] = useState({
    id: null,
    title: "",
    event_category_id: "",
    start_date: "",
    end_date: "",
    start_time: "",
    end_time: "",
    attachment: null,
    message: "",
    user_types: [],
  });
  const [editFormData, setEditFormData] = useState(null); // Stores data for editing
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString(undefined, options);
  };
  const capitalizeWords = (str) => {
    return str
      .split(" ") // Split the string into words
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter of each word
      .join(" "); // Join the words back into a string
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (value) => {
    setFormData({ ...formData, user_types: value });
  };
  useEffect(() => {
    // Fetch event categories when the modal is opened
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/admin/events/event_master/list.php?school_id=${schoolId}`
        );
        const result = await response.json();
        if (result.success) {
          setCategories(result.data); // Assuming 'data' contains the event categories
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch categories.");
      }
    };

    if (schoolId) {
      fetchCategories();
    }
  }, [schoolId]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/admin/events/event/list_all_event.php?school_id=${schoolId}`
        );
        console.log("da", response);

        if (response.data.success) {
          setEvents(response.data.data.events);
        } else {
          console.error("Failed to fetch events.");
        }
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchEvents();
  }, []);

  const userTypeMapping = {
    3: "Student",
    2: "Teacher",
    4: "Guardian",
    // Add more mappings as needed
  };

  const handleEventClick = async (event) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/admin/events/event/view_event.php?event_id=${event.id}`
      );

      console.log("Response:", response);

      if (response.data.success) {
        const fetchedEvent = response.data.data.event;

        // Update the form data including user_types
        setFormData({
          id: fetchedEvent.id,
          title: fetchedEvent.event_title,
          event_category_id: fetchedEvent.event_master_id,
          start_date: fetchedEvent.start_date,
          end_date: fetchedEvent.end_date,
          start_time: fetchedEvent.start_time,
          end_time: fetchedEvent.end_time,
          message: fetchedEvent.message,
          user_types: fetchedEvent.user_types || [], // Ensure user_types are set correctly
          attachment: fetchedEvent.attachment,
          teacher_id: fetchedEvent.teacher_id,
        });

        // Set a random background color for the event
        const eventColor = getRandomColor();
        setEventColor(eventColor);

        // Open the modal
        onOpenDetailModal();
      } else {
        toast({
          title: "Error",
          description: "Failed to fetch event details.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error("Error fetching event details:", error);
      toast({
        title: "Error",
        description: "An error occurred while fetching the event details.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const fetchTeachers = async () => {
    try {
      const jwt = sessionStorage.getItem("jwt");
      const school_id = sessionStorage.getItem("school_id"); // If JWT is needed

      const response = await axios.get(
        `${BASE_URL}/admin/staff/staff_list.php?school_id=${school_id}`,
        {
          headers: {
            Authorization: `Bearer ${jwt}`,
          },
        }
      );
      console.log("staff_list", response);
      setTeachers(response.data.data); // Set teachers data

      // if (response.data.status === "success") {
      //   setTeachers(response.data.data); // Set teachers data
      // } else {
      //   setError(response.data.message || "Error fetching teachers");
      // }
    } catch (error) {
      console.error("Error fetching teachers:", error);
      setError("Network Error: " + (error.message || error));
    } finally {
      setLoading(false);
    }
  };

  // Call fetchTeachers on component mount
  useEffect(() => {
    fetchTeachers();
  }, []);

  const handleSaveEditEvent = async () => {
    if (!editFormData) {
      console.log("No form data to save."); // Add logging to check if there's form data
      return;
    }

    console.log("Saving edited event:", editFormData); // Add logging to see the data being sent

    try {
      const response = await axios.put(
        `${BASE_URL}/admin/events/event/edit_event.php`,
        {
          event_id: editFormData.id,
          event_title: editFormData.title,
          event_master_id: editFormData.event_category_id,
          start_date: editFormData.start_date,
          end_date: editFormData.end_date,
          start_time: editFormData.start_time,
          end_time: editFormData.end_time,
          teacher_id: editFormData.teacher_id,
          message: editFormData.message,
          user_types: editFormData.user_types,
          pass: sessionStorage.getItem("user_id"), // Ensure session user id is available
        }
      );
      const p = {
        event_id: editFormData.id,
        event_title: editFormData.title,
        event_master_id: editFormData.event_category_id,
        start_date: editFormData.start_date,
        end_date: editFormData.end_date,
        start_time: editFormData.start_time,
        end_time: editFormData.end_time,
        teacher_id: editFormData.id,
        message: editFormData.message,
        user_types: editFormData.user_types,
        pass: sessionStorage.getItem("user_id"),
      };
      console.log("ediitt", p);

      if (response.data.success) {
        toast.success("Event updated successfully.");
        setEvents(
          events.map((event) =>
            event.id === editFormData.id ? { ...event, ...editFormData } : event
          )
        );
        setIsEditModalOpen(false);
      } else {
        toast.error("Failed to update event.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the event.");
    }
  };
  const handleEditClick = () => {
    setEditFormData(formData); // Set the edit form data to the current form data
    setIsEditModalOpen(true); // Open the edit modal
  };

  const handleDeleteEvent = async (eventId) => {
    try {
      const response = await fetch(
        `${BASE_URL}/admin/events/delete_event.php`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            event_id: eventId,
            pass: sessionStorage.getItem("user_id"),
          }),
        }
      );
      const result = await response.json();
      if (result.success) {
        toast.success("Event deleted successfully");
        setEvents(events.filter((event) => event.id !== eventId));
      } else {
        toast.error("Failed to delete event.");
      }
    } catch (error) {
      toast.error("An error occurred while deleting the event.");
    }
  };

  const getRandomColor = () => {
    const pastelColors = [
      "#FFFAE3", // Soft Yellow
      "#E3FCEC", // Soft Green
      "#E3F2FD", // Soft Blue
      "#FFF5E3", // Soft Peach
      "#FCE7F3", // Soft Pink
      "#F5E8FF", // Soft Lavender
      "#EAF4FC", // Soft Sky Blue
      "#FDF6E3", // Soft Cream
    ];
    const randomIndex = Math.floor(Math.random() * pastelColors.length);
    return pastelColors[randomIndex];
  };

  // Example usage
  console.log(getRandomColor());

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();
  const today = new Date();

  const generateCalendar = (month, year, today, events) => {
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    let calendarDays = [];
    let dayNumber = 1;

    for (let i = 0; i < 6; i++) {
      calendarDays[i] = [];
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < firstDay) {
          calendarDays[i].push(null);
        } else if (dayNumber <= daysInMonth) {
          const currentDay = new Date(year, month, dayNumber);
          const isToday = today.toDateString() === currentDay.toDateString();

          const eventsForDay = Array.isArray(events)
            ? events.filter(
                (event) =>
                  format(new Date(event.start_date), "yyyy-MM-dd") ===
                  format(currentDay, "yyyy-MM-dd")
              )
            : [];

          calendarDays[i].push({
            day: dayNumber,
            isToday,
            events: eventsForDay,
          });
          dayNumber++;
        } else {
          calendarDays[i].push(null);
        }
      }
    }
    return calendarDays;
  };

  // JavaScript to assign random soft colors
  document.querySelectorAll(".event-box").forEach((box) => {
    const randomColor = `hsl(${Math.random() * 360}, 70%, 85%)`;
    box.style.backgroundColor = randomColor;
  });

  const calendarDays = generateCalendar(month, year, today, events);

  return (
    <>
      {/* Calendar UI */}
      <style>
        {`
  .calendar-container {
    margin: 20px auto;
    padding: 15px ;
    max-width: 100%;
    overflow-x: auto;
    background: linear-gradient(135deg, #e0f7fa, #f1f8e9);
    border-radius: 12px;
    box-shadow: 0 4px 10px rgba(0, 128, 128, 0.15);
  }

  .calendar {
    width: 100%;
    min-width: 768px;
    border-collapse: collapse;
    border-radius: 12px;
    overflow: hidden;
    background: white;
  }

  .headerr {

    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    flex-wrap: wrap;
    gap: 10px;
  }

  .headerr h2 {
    font-size: clamp(1.5rem, 2.5vw, 1.8rem);
    margin: 0;
    background: -webkit-linear-gradient(#00796b, #004d40);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    text-align: center;
  }

  .headr {
    background-color: #00897b;
    color: white;
    padding: 8px 16px;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    white-space: nowrap;
    font-size: clamp(1rem, 1.5vw, 1.2rem);
    transition: background-color 0.3s ease;
  }

  .headr:hover {
    background-color: #00695c;
  }

  table {
    width: 100%;
    border: 1px solid #cce7e7;
    table-layout: fixed;
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 3px 6px rgba(0, 128, 128, 0.15);
  }

  table th {
    padding: 12px;
    font-size: clamp(1rem, 1.5vw, 1.2rem);
    background: linear-gradient(135deg, #80cbc4, #004d40);
    color: white;
    text-align: left;
    border-bottom: 1px solid #b2dfdb;
  }

  table td {
    padding: 10px;
    height: clamp(80px, 12vh, 120px);
    vertical-align: top;
    position: relative;
    border-bottom: 1px solid #e0f2f1;
    font-size: clamp(0.9rem, 1.5vw, 1rem);
    color: #004d40;
  }

  table tr:last-child td {
    border-bottom: none;
  }

.event-box {
    font-size: clamp(0.85rem, 1.5vw, 1rem);
    padding: 6px 8px;
    border-radius: 6px;
    margin-bottom: 6px;
    display: block;
    text-align: left;
    font-weight: 500;
    color: #333; /* Dark text for better readability */
}


  /* Modal Responsiveness */
  @media (max-width: 480px) {
    .chakra-modal__content {
      margin: 10px !important;
      width: calc(100% - 20px) !important;
    }

    .chakra-modal__header {
      font-size: 1.4rem !important;
      padding: 12px !important;
    }

    .chakra-modal__body {
      padding: 12px !important;
    }

    .chakra-form-control {
      margin-top: 10px !important;
    }
  }

  /* Scrollbar Styling */
  .calendar-container::-webkit-scrollbar {
    height: 8px;
  }

  .calendar-container::-webkit-scrollbar-track {
    background: #e6f7f7;
  }

  .calendar-container::-webkit-scrollbar-thumb {
    background: #80cbc4;
    border-radius: 4px;
  }

  .calendar-container::-webkit-scrollbar-thumb:hover {
    background: #4db6ac;
  }

  /* Event Container Scrolling */
  .events-container {
    max-height: 100%;
    overflow-y: auto;
    scrollbar-width: thin;
  }

  .events-container::-webkit-scrollbar {
    width: 4px;
  }

  .events-container::-webkit-scrollbar-thumb {
    background: #80cbc4;
    border-radius: 2px;
  }
`}
      </style>
      <Box className="calendar-box" overflowX="auto">
        <div className="calendar-container">
          <div className="calendar">
            <div className="headerr">
              <button
                className="headr"
                onClick={() => setCurrentDate(new Date(year, month - 1))}
              >
                Previous
              </button>
              <h2>
                {monthNames[month]} {year}
              </h2>
              <button
                className="headr"
                onClick={() => setCurrentDate(new Date(year, month + 1))}
              >
                Next
              </button>
            </div>
            <div className="spacer"></div>
            <table>
              <thead>
                <tr>
                  <th>Sun</th>
                  <th>Mon</th>
                  <th>Tue</th>
                  <th>Wed</th>
                  <th>Thu</th>
                  <th>Fri</th>
                  <th>Sat</th>
                </tr>
              </thead>
              <tbody>
                {calendarDays.map((week, index) => (
                  <tr key={index}>
                    {week.map((day, dayIndex) =>
                      day ? (
                        <td
                          key={dayIndex}
                          className={`day ${day.isToday ? "today" : ""}`}
                        >
                          <div>{day.day}</div>
                          {/* Render all events for the day */}
                          {day.events.length > 0 && (
                            <div className="events-container">
                              {day.events.map((event, eventIndex) => (
                                <Box
                                  key={eventIndex}
                                  className="event-box"
                                  bg={getRandomColor()}
                                  color="black"
                                  p={2}
                                  borderRadius="md"
                                  overflow="hidden"
                                  textOverflow="ellipsis"
                                  whiteSpace="nowrap"
                                  title={event.event_title}
                                  onClick={() => {
                                    handleEventClick(event);
                                    console.log("Event clicked:", event);
                                  }}
                                  mb={2}
                                >
                                  {event.event_title.length > 10
                                    ? `${event.event_title.slice(0, 10)}...`
                                    : event.event_title}
                                </Box>
                              ))}
                            </div>
                          )}
                        </td>
                      ) : (
                        <td key={dayIndex}></td>
                      )
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Box>

      {/* Event Detail Modal */}
      <Modal isOpen={isDetailModalOpen} onClose={onCloseDetailModal}>
        <ModalOverlay />
        <ModalContent width="900px" maxHeight="90vh" bg={eventColor}>
          <ModalHeader
            fontSize="md"
            fontWeight="bold"
            borderBottom="1px solid grey"
            bg={eventColor}
          >
            Event Details
            {/* Edit Icon Button */}
            <IconButton
              icon={<EditIcon />}
              onClick={() => {
                onCloseDetailModal(); // Close the current modal
                handleEditClick(); // Open the edit modal
              }}
              variant="outline"
              colorScheme="teal"
              aria-label="Edit Event"
              ml={2} // Add margin-left for spacing
            />
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody overflowY="auto" py={6} px={8} bg={eventColor}>
            {formData && (
              <>
                <Text fontSize="md" mb={4}>
                  {capitalizeWords(formData.title)}
                </Text>
                <Text fontSize="md" color="gray.600" mb={6}>
                  {capitalizeWords(formData.message)}
                </Text>
                <Box mb={6}>
                  <Flex
                    justifyContent="space-between"
                    alignItems="flex-start"
                    mb={4}
                  >
                    {/* Start Date & Time */}
                    {formData.start_date && (
                      <Box>
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.700"
                        >
                          Start Date
                        </Text>
                        <Text fontSize="md" color="gray.500">
                          {formatDate(formData.start_date)}
                        </Text>
                        {formData.start_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="medium"
                              color="gray.700"
                              mt={2}
                            >
                              Start Time
                            </Text>
                            <Text fontSize="md" color="gray.500">
                              {formData.start_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}

                    {/* End Date & Time */}
                    {formData.end_date && (
                      <Box textAlign="right">
                        <Text
                          fontSize="sm"
                          fontWeight="medium"
                          color="gray.700"
                        >
                          End Date
                        </Text>
                        <Text fontSize="md" color="gray.500">
                          {formatDate(formData.end_date)}
                        </Text>
                        {formData.end_time && (
                          <>
                            <Text
                              fontSize="sm"
                              fontWeight="medium"
                              color="gray.700"
                              mt={2}
                            >
                              End Time
                            </Text>
                            <Text fontSize="md" color="gray.500">
                              {formData.end_time}
                            </Text>
                          </>
                        )}
                      </Box>
                    )}
                  </Flex>

                  {/* Attachment Section */}
                  {formData.attachment && (
                    <Box mt={6}>
                      <Text fontSize="sm" fontWeight="medium" color="gray.700">
                        Attachment
                      </Text>
                      <Button
                        as="a"
                        href={formData.attachment}
                        download
                        colorScheme="teal"
                        variant="outline"
                        size="sm"
                        mt={2}
                      >
                        Download Attachment
                      </Button>
                    </Box>
                  )}
                </Box>

                {/* Event Audience */}
                {formData.user_types && formData.user_types.length > 0 && (
                  <Box mt={6}>
                    <Text
                      fontSize="sm"
                      fontWeight="medium"
                      color="gray.700"
                      mb={2}
                    >
                      Event For:
                    </Text>
                    <Flex wrap="wrap" gap={2}>
                      {formData.user_types.map((id, index) => (
                        <Box
                          key={index}
                          p={2}
                          bg="teal.100"
                          borderRadius="md"
                          textAlign="center"
                        >
                          <Text fontSize="sm" color="teal.600">
                            {userTypeMapping[id] || "Unknown"}
                          </Text>
                        </Box>
                      ))}
                    </Flex>
                  </Box>
                )}
              </>
            )}
          </ModalBody>
          <Divider />
          <ModalFooter>
            {/* <Button colorScheme="teal" onClick={onCloseDetailModal}>
              Close
            </Button> */}
          </ModalFooter>
        </ModalContent>

        {/* Edit Modal */}
      </Modal>
      <Modal
        size="lg"
        motionPreset="slideInBottom"
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            {" "}
            <Icon as={FaEdit} boxSize={5} mr={2} />
            Edit Event Form
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            overflowY="auto"
            px={4}
            css={{
              "&::-webkit-scrollbar": {
                width: "6px",
              },
              "&::-webkit-scrollbar-track": {
                background: "rgba(255, 255, 255, 0.2)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb": {
                background: "rgba(173, 216, 230, 0.6)",
                borderRadius: "10px",
                backdropFilter: "blur(8px)",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                background: "rgba(173, 216, 230, 0.9)",
              },
            }}
          >
            {editFormData && (
              <>
                {/* Title */}
                <FormControl id="title">
                  <FormLabel>Title</FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={editFormData.title}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        title: e.target.value,
                      })
                    }
                  />
                </FormControl>

                {/* Category */}
                <FormControl mt={4} isRequired>
                  <FormLabel>Event Category</FormLabel>
                  <Select
                    name="event_category_id"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={editFormData.event_category_id}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        event_category_id: e.target.value,
                      })
                    } // Update state on change
                  >
                    <option value="">Select category</option>
                    {categories.map((category) => (
                      <option key={category.id} value={category.id}>
                        {category.event_master}{" "}
                        {/* Assuming 'event_master' is the category name */}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl mt={4} isRequired>
                  <FormLabel>Allocated Teachers</FormLabel>

                  <Select
                    name="allocated_teacher_id"
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    placeholder="Select Teacher"
                    value={editFormData.teacher_id} // Bind the selected teacher's ID
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        teacher_id: e.target.value,
                      })
                    } // Update state on change
                  >
                    {teachers.map((teacher) => (
                      <option key={teacher.id} value={teacher.id}>
                        {teacher.name}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                {/* Start Date & End Date in one row */}
                <Flex mt={4} gap={4}>
                  <FormControl id="start_date" flex="1">
                    <FormLabel>Start Date</FormLabel>
                    <Input
                      type="date"
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={editFormData.start_date}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          start_date: e.target.value,
                        })
                      }
                    />
                  </FormControl>

                  <FormControl id="end_date" flex="1">
                    <FormLabel>End Date</FormLabel>
                    <Input
                      type="date"
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={editFormData.end_date}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          end_date: e.target.value,
                        })
                      }
                    />
                  </FormControl>
                </Flex>

                {/* Start Time & End Time in one row */}
                <Flex mt={4} gap={4}>
                  <FormControl id="start_time" flex="1">
                    <FormLabel>Start Time</FormLabel>
                    <Input
                      type="time"
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={editFormData.start_time}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          start_time: e.target.value,
                        })
                      }
                    />
                  </FormControl>

                  <FormControl id="end_time" flex="1">
                    <FormLabel>End Time</FormLabel>
                    <Input
                      type="time"
                      bg="white"
                      _hover={{ borderColor: "teal.300" }}
                      value={editFormData.end_time}
                      onChange={(e) =>
                        setEditFormData({
                          ...editFormData,
                          end_time: e.target.value,
                        })
                      }
                    />
                  </FormControl>
                </Flex>

                {/* Message */}
                <FormControl id="message" mt={4}>
                  <FormLabel>Message</FormLabel>
                  <Input
                    bg="white"
                    _hover={{ borderColor: "teal.300" }}
                    value={editFormData.message}
                    onChange={(e) =>
                      setEditFormData({
                        ...editFormData,
                        message: e.target.value,
                      })
                    }
                  />
                </FormControl>

                {/* Event for Checkbox */}
                <FormControl mt={4}>
                  <FormLabel>Event for</FormLabel>
                  <CheckboxGroup
                    colorScheme="teal"
                    value={editFormData.user_types.map(String)} // Convert IDs to strings if needed
                    onChange={(selectedUserTypes) =>
                      setEditFormData({
                        ...editFormData,
                        user_types: selectedUserTypes.map(Number), // Convert back to numbers if required
                      })
                    }
                  >
                    <Stack spacing={[1, 1]} direction={["column", "row"]}>
                      <Checkbox value="3">Student</Checkbox>
                      <Checkbox value="2">Teacher</Checkbox>
                      <Checkbox value="4">Guardian</Checkbox>
                    </Stack>
                  </CheckboxGroup>
                </FormControl>
              </>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              bgGradient="linear(to-r, teal.400, teal.600)"
              color="white"
              _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
              onClick={() => {
                handleSaveEditEvent(); // Save the event
                onCloseDetailModal(); // Close the modal
              }}
            >
              Save
            </Button>

            {/* <Button onClick={() => setIsEditModalOpen(false)}>Cancel</Button> */}
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Calendar;
